module.exports = __webpack_public_path__ + "static/media/1013947.d5ad5130.jpg";